<template>
  <wa-page :is-showing-bandana="false" :is-showing-sitewide-modal="false">
    <wa-page-header-limited
      slot="header"
      key="header"
      title="Thanks for Your Icon Commission"
    />

    <main
      slot="content"
      role="main"
      class="app-content padding-y-7xl"
    >
      <div class="container">
        <commission-1-success
          v-if="currentProduct.sku === 'CI-SINGLE'"
          :theme="theme"
        />
        <commission-6-success
          v-if="currentProduct.sku === 'CI-SIXPACK'"
          :theme="theme"
        />
        <commission-24-success
          v-if="currentProduct.sku === 'CI-CASE24'"
          :theme="theme"
        />
        <commission-logo-success
          v-if="currentProduct.sku === 'CI-BRAND'"
          :theme="theme"
        />

        <hr
          class="margin-bottom-4xl"
          style="--hr-border-color: var(--white); --hr-border-width: var(--border-width-xs)"
        />

        <success-footer
          :is-new-account="isNewAccount"
          :theme="theme"
        />
      </div>
    </main>

    <wa-page-footer-simple slot="footer" />
  </wa-page>
</template>

<script>
  import { get, sample } from 'lodash'
  import Commission1Success from './products/Commission1Success'
  import Commission6Success from './products/Commission6Success'
  import Commission24Success from './products/Commission24Success'
  import CommissionLogoSuccess from './products/CommissionLogoSuccess'
  import SuccessFooter from './SuccessFooter'

  export default {
    name: 'SuccessView',

    components: {
      Commission1Success,
      Commission6Success,
      Commission24Success,
      CommissionLogoSuccess,
      SuccessFooter
    },

    props: {
      currentProduct: {
        type: Object,
        required: true
      },

      productSku: {
        type: String,
        required: true
      },

      isNewAccount: {
        type: Boolean,
        required: true
      },

      theme: {
        type: String,
        required: true
      }
    },

    computed: {
      color() {
        return get(this, ['currentProduct', 'sku']) === 'CI-BRAND' ? 'violet' : 'blue'
      },

      selectedSalutation() {
        const options = ['Great Success!', 'Somehow You Got Even More Awesome!', 'Font-Freaking-Tastic!']

        return sample(options)
      }
    }
  }
</script>
